import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Home.css";

export default function Home() {
  const [examens, setExamens] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [tempSelectedTabs, setTempSelectedTabs] = useState([]);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const navigate = useNavigate();

  const modalityMap = {
    "Radiographie conventionnelle": "CR",
    "Radiographie numérique": "DX",
    "Tomodensitométrie (Scanner)": "Scanner",
    "Imagerie par résonance magnétique (IRM)": "IRM",
    "Échographie": "ECHO",
    "Médecine nucléaire": "MN",
    "Tomographie par émission de positons (TEP/PET scan)": "TEP/PET ",
    "Angiographie": "ANGIO",
    "Mammographie": "MAMMO",
    "Fluoroscopie": "FLUORO",
    "Endoscopie": "ENDO",
    "Densitométrie osseuse (DXA)": "DENSI",
    "Capture secondaire d'image": "CAPTURE",
    "Autre modalité": "AUTRE",
    "IRM (non standard, mappée vers MR)": "IRM MR"
  };

 const [advancedFilters, setAdvancedFilters] = useState({
  patientNom: "",
  patientPrenom: "",
  radiologueNom: "",
  type: "",
  criticite: "",
  statut: "", // <-- nouveau champ
  dateMin: "",
  dateMax: "",
});
  const [showAdvancedSearchModal, setShowAdvancedSearchModal] = useState(false);


  useEffect(() => {
  const handleClickOutside = (e) => {
    if (!e.target.closest('.profile-menu') && !e.target.closest('.profil')) {
      setShowProfileMenu(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);


  useEffect(() => {
    const fetchExamens = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token non trouvé dans le stockage local.");
        return;
      }

      try {
        const response = await axios.get(process.env.REACT_APP_EUREKA_PACS_URL + "/api/examens", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setExamens(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Erreur :", error);
      }
    };

    fetchExamens();
  }, []);

  const filteredExamens = examens.filter((examen) => {
    if (selectedTabs.length > 0 && !selectedTabs.includes(examen.type)) {
      return false;
    }

    const { patientNom, patientPrenom, radiologueNom, type, criticite, dateMin, dateMax } = advancedFilters;

    const nomPatient = examen.patient?.personne?.nom?.toLowerCase() || "";
    const prenomPatient = examen.patient?.personne?.prenom?.toLowerCase() || "";
    const nomRadiologue = examen.radiologue?.personne?.nom?.toLowerCase() || "";
    const typeExamen = examen.type?.toLowerCase() || "";
    const criticiteExamen = examen.criticite?.toLowerCase() || "";
    const dateExamen = examen.created_at ? new Date(examen.created_at) : null;

    if (patientNom && !nomPatient.includes(patientNom.toLowerCase())) return false;
    if (patientPrenom && !prenomPatient.includes(patientPrenom.toLowerCase())) return false;
    if (radiologueNom && !nomRadiologue.includes(radiologueNom.toLowerCase())) return false;
    if (type && !typeExamen.includes(type.toLowerCase())) return false;
    if (criticite && !criticiteExamen.includes(criticite.toLowerCase())) return false;
    if (dateMin && dateExamen && new Date(dateMin) > dateExamen) return false;
    if (dateMax && dateExamen && new Date(dateMax) < dateExamen) return false;
    if (advancedFilters.statut && examen.statut !== advancedFilters.statut) return false;
if (advancedFilters.criticite && examen.criticite !== advancedFilters.criticite) return false;


    const fullText = Object.values(examen)
      .flatMap((value) => {
        if (value && typeof value === "object") {
          return Object.values(value).flatMap((nestedValue) =>
            nestedValue && typeof nestedValue === "object"
              ? Object.values(nestedValue)
              : nestedValue
          );
        }
        return value;
      })
      .join(" ")
      .toLowerCase();

    return fullText.includes(searchTerm.toLowerCase());
  });


  const tabNames = Object.keys(modalityMap);

  const toggleModal = () => {
    setTempSelectedTabs(selectedTabs);
    setShowFilterModal(!showFilterModal);
  };

  const handleCheckboxChange = (modality) => {
    setTempSelectedTabs((prev) =>
      prev.includes(modality)
        ? prev.filter((m) => m !== modality)
        : [...prev, modality]
    );
  };

  const applyFilters = () => {
    setSelectedTabs(tempSelectedTabs);
    setShowFilterModal(false);
  };

  function calculerAge(dateNaissanceStr) {
    if (!dateNaissanceStr) return null;
    const naissance = new Date(dateNaissanceStr);
    const maintenant = new Date();
    let age = maintenant.getFullYear() - naissance.getFullYear();
    const m = maintenant.getMonth() - naissance.getMonth();
    if (m < 0 || (m === 0 && maintenant.getDate() < naissance.getDate())) {
      age--;
    }
    return age;
  }

  return (
    <div className="dark">
      <header>
        <div className="logo">
          <img src="logo.png" alt="logo" />
          <h1>Eureka PACS</h1>
        </div>
        <div className="controls">
          <img src="/recherche.png" alt="Loup" className="icon wolf-icon" />
          <img src="/refresh-icon.png" alt="Actualisation" className="icon refresh-icon" />
          <input type="text" placeholder="Rechercher par patient" onChange={(e) => setSearchTerm(e.target.value)} />
          <button onClick={toggleModal}>Filtrer par modalité</button>
          <button onClick={() => setShowAdvancedSearchModal(true)}>
            Recherche avancée
          </button>
          <img
            src="/profil.png"
            alt="profil"
            className="icon profil"
            onClick={() => setShowProfileMenu(!showProfileMenu)}
            style={{ cursor: "pointer" }}
        />
        </div>
      </header>

      <main>
        <table>
          <thead>
            <tr>
              <th>Numero de l'examen</th>
              <th>Nom de l'examen</th>
              <th>Type de l'examen</th>
              <th>Date de l'examen</th>
              <th>Statut de l'examen</th>
              <th>Criticité de l'examen</th>
              <th>Nom & Prénom du patient</th>
              <th>Âge du patient</th>
              <th>Sexe patient</th>
              <th>Radiologue</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredExamens.map((examen) => (
              <tr
                key={examen.id}
                className={
                  examen.statut === "TERMINE"
                    ? "green-background"
                    : examen.statut === "AVEC_CR"
                    ? "orange-background"
                    : "red-background"
                }
                onClick={() => navigate(`/examens/${examen.id}`)}
                style={{ cursor: "pointer" }}
              >
                <td>{examen.id}</td>
                <td>{examen.nom}</td>
                <td>{examen.type}</td>
                <td>
                  {examen.created_at
                    ? new Date(examen.created_at).toISOString().replace("T", " ").slice(0, 16).split(" ")[0].split("-").reverse().join("/") +
                      " à " +
                      new Date(examen.created_at).toISOString().slice(11, 16)
                    : ""}
                </td>
                <td>{examen.statut === "TERMINE" ? "Validé" : "À validé"}</td>
                <td>{examen.criticite}</td>
                <td>{examen.patient?.personne?.nom} {examen.patient?.personne?.prenom || ""}</td>
                <td>{calculerAge(examen.patient?.personne?.date_naissance)} ans</td>
                <td>{examen.patient?.personne?.sexe}</td>
                <td>{examen.radiologue?.personne?.nom || ""} {examen.radiologue?.personne?.prenom || ""}</td>
                <td>
                  <img src="/rapport.png" alt="rapport" className="icon rapport" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </main>

      {showFilterModal && (
        <div className="modal-overlay">
          <div className="exam-modal">
            <h3>Sélectionnez les modalités à afficher</h3>
            <div className="modal-checkboxes">
              {tabNames.map((tab, index) => (
                <label key={index} className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={tempSelectedTabs.includes(tab)}
                    onChange={() => handleCheckboxChange(tab)}
                  />
                  {tab}
                </label>
              ))}
            </div>
            <div className="modal-buttons">
              <button className="apply-button" onClick={applyFilters}>
                Appliquer les filtres
              </button>
              <button
                className="reset-button"
                onClick={() => {
                  setSelectedTabs([]);
                  setShowFilterModal(false);
                }}
              >
                Réinitialiser
              </button>
            </div>
          </div>
        </div>
      )}

      {showAdvancedSearchModal && (
        <div className="modal-overlay">
          <div className="exam-modal">
            <h3>Recherche Avancée</h3>
            <div className="advanced-search-inputs">
              <input placeholder="Nom du patient" onChange={(e) => setAdvancedFilters({ ...advancedFilters, patientNom: e.target.value })} />
              <input placeholder="Prénom du patient" onChange={(e) => setAdvancedFilters({ ...advancedFilters, patientPrenom: e.target.value })} />
              <input placeholder="Nom du radiologue" onChange={(e) => setAdvancedFilters({ ...advancedFilters, radiologueNom: e.target.value })} />
              <label>
                Date minimale :
                <input type="date" onChange={(e) => setAdvancedFilters({ ...advancedFilters, dateMin: e.target.value })} />
              </label>
              <label>
                Date maximale :
                <input type="date" onChange={(e) => setAdvancedFilters({ ...advancedFilters, dateMax: e.target.value })} />
              </label>
              <label>
              Statut :
              <select
                value={advancedFilters.statut}
                onChange={(e) => setAdvancedFilters({ ...advancedFilters, statut: e.target.value })}
              >
                <option value="">Tous</option>
                <option value="AVEC_CR">À valider</option>
                <option value="TERMINE">Validé</option>
              </select>
            </label>

            <label>
              Criticité :
              <select
                value={advancedFilters.criticite}
                onChange={(e) => setAdvancedFilters({ ...advancedFilters, criticite: e.target.value })}
              >
                <option value="">Toutes</option>
                <option value="Faible">Faible</option>
                <option value="Moyen">Moyen</option>
                <option value="Forte">Forte</option>
              </select>
            </label>

            </div>
            <div className="modal-buttons">
              <button className="apply-button" onClick={() => setShowAdvancedSearchModal(false)}>Appliquer</button>
              <button className="reset-button" onClick={() => {
                setAdvancedFilters({
                  patientNom: "",
                  patientPrenom: "",
                  radiologueNom: "",
                  type: "",
                  criticite: "",
                  dateMin: "",
                  dateMax: "",
                });
                setShowAdvancedSearchModal(false);
              }}>Réinitialiser</button>
            </div>
          </div>
        </div>
      )}

      {showProfileMenu && (
        <div className="profile-menu">
          <button>
            <span role="img" aria-label="profil">👤</span> Afficher le profil
          </button>
          <button>
            <span role="img" aria-label="réglages">⚙️</span> Réglages
          </button>
          <button onClick={() => {
            localStorage.removeItem("token");
            navigate("/");
          }}>
            <span role="img" aria-label="déconnexion">🔒</span> Déconnexion
          </button>
        </div>
        )}



    </div>
  );
}
